import React from 'react';
import { CheckIcon } from 'lucide-react';
const trustLines = ['Pago 100% seguro con Mercado Pago', 'Descarga instantánea — en 2 minutos lo tenés en tu mail', 'Acceso de por vida — tuyo para siempre', 'Garantía de 7 días — sin preguntas'];
export function Footer() {
  return <footer className="py-12 px-6 bg-charcoal-900 border-t border-charcoal-800" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-8" data-id="element-27">
          {trustLines.map((line, index) => <span key={index} className="flex items-center gap-2 text-offwhite/70 text-sm" data-id="element-28">
              <CheckIcon className="w-4 h-4 text-mutedteal" data-id="element-29" />
              {line}
            </span>)}
        </div>

        <p className="text-charcoal-600 text-sm font-light text-center" data-id="element-30">
          &copy; {new Date().getFullYear()} El Reset de 72 Horas. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}